(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ExportPraxedoDeleteController',ExportPraxedoDeleteController);

    ExportPraxedoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExportPraxedo'];

    function ExportPraxedoDeleteController($uibModalInstance, entity, ExportPraxedo) {
        var vm = this;

        vm.exportPraxedo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ExportPraxedo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
